import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, computed, inject } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <img src="./assets/layout/images/favicon.ico" alt="SigosPM" />
                <span class="footer-app-name">Sigos PM - Manutenção</span>
            </div>
            <span class="footer-copyright">&#169; MaxProcess. Solução Sigos PM. Todos os direitos reservados - 2026</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
